import { render, staticRenderFns } from "./Postkarte.vue?vue&type=template&id=5352b88f&"
import script from "./Postkarte.vue?vue&type=script&lang=js&"
export * from "./Postkarte.vue?vue&type=script&lang=js&"
import style0 from "./Postkarte.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports